import { render, staticRenderFns } from "./UsersManager.vue?vue&type=template&id=3640ac0f"
import script from "./UsersManager.vue?vue&type=script&lang=js"
export * from "./UsersManager.vue?vue&type=script&lang=js"
import style0 from "./users-manager-styles.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./UsersManager.vue?vue&type=style&index=1&id=3640ac0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports